<template>
  <div class="qandaOuter">
    <div class="qandaInnerTop pointer" @click.prevent="toggleVraag()">
      <div class="row">
        <div class="col-sm-12 col-xs-12" v-if="wXS === true || wSM === true">
          <div class="pull-right">
            <span class="spanPrio" v-if="tblQandACodePrio === 3">
              <font-awesome-icon icon="exclamation" :class="'iconexclamation'" />
            </span>
            &nbsp;&nbsp;
            <span @click="reply()">
              &nbsp;&nbsp;
              <font-awesome-icon icon="reply" class="pointer" />&nbsp;&nbsp;
            </span>
            &nbsp;&nbsp;
            <span>
              <font-awesome-icon
                icon="chevron-down"
                class="initial pointer"
                v-bind:class="{ hideIcon: detailsVisible }"
              />
              <font-awesome-icon
                icon="chevron-up"
                class="initial pointer"
                v-bind:class="{ hideIcon: !detailsVisible }"
              />
            </span>
          </div>
        </div>
      </div>
      <div class="row pnlDate">
        <div class="col-md-9 col-sm-9">
          <span class="spanDate">{{ postedDate }}</span>
          <br v-if="wXS === true || wSM === true" />
          <span v-html="translation(15367) + ': ' + tblQandASubject" class="pointer"></span>
          <br v-if="wXS === true || wSM === true" />
          <span class="spanName">{{ postedName }}</span>
        </div>
        <div class="col-md-3 col-sm-3" v-if="wLG === true || wXL === true || wMD === true">
          <div class="pull-right">
            <span class="spanPrio" v-if="tblQandACodePrio === 3">
              <font-awesome-icon icon="exclamation" :class="'iconexclamation'" />
            </span>
            &nbsp;&nbsp;
            <span @click="reply()">
              &nbsp;&nbsp;
              <font-awesome-icon icon="reply" class="pointer" />&nbsp;&nbsp;
            </span>
            &nbsp;&nbsp;
            <span>
              <font-awesome-icon
                icon="chevron-down"
                class="initial pointer"
                v-bind:class="{ hideIcon: detailsVisible }"
              />
              <font-awesome-icon
                icon="chevron-up"
                class="initial pointer"
                v-bind:class="{ hideIcon: !detailsVisible }"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="qandaInnerBottom" v-if="detailsVisible">
      <div class="row margin10bottom pointer" @click.prevent="toggleVraag()">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <span class="spanOntvangers">{{ postedNameTo }}</span>
        </div>
      </div>
      <div class="row margin10bottom" v-if="qandaDescriptiondata">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <span v-html="qandaDescriptiondata.tblQandADescriptionText"></span>
        </div>
      </div>
      <div class="row margin10bottom spanQandABijlage" v-if="qandaDescriptiondata && qandaDescriptiondata.documenten">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="xvuploadclass">
            <XVupload
              maximumfilecount="1"
              name="uploadName"
              :data-vv-as="translation(14930)"
              v-model="qandaDescriptiondata.documenten"
              :bijlageicon="true"
            ></XVupload>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="replymessages.data !== [] && antwoordenVisible">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="row rowreplymsg" v-for="(msg, i) in replymessages.data" :key="i">
          <div class="col-md-12 col-sm-12 col-xs-12 colreplymsg">
            <div class="replyinnertop pointer" v-on:click="toggleAntwoord(msg.tblQandAID)">
              <div class="row" v-if="wSM === true || wXS === true">
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <div class="pull-right">
                    <span class="spanPrio" v-if="msg.tblQandACodePrio === 3">
                      <font-awesome-icon icon="exclamation" :class="'iconexclamation'" />
                    </span>
                    &nbsp;&nbsp;
                    <span v-on:click="ReplyReply(msg.windowOpen, msg.urlQandA)">
                      &nbsp;&nbsp;
                      <font-awesome-icon icon="reply" class="pointer" />&nbsp;&nbsp;
                    </span>
                    &nbsp;&nbsp;
                    <span>
                      <font-awesome-icon
                        icon="chevron-down"
                        class="initial pointer"
                        v-bind:class="{ hideIcon: msg.replymessages.toggle }"
                      />
                      <font-awesome-icon
                        icon="chevron-up"
                        class="initial pointer"
                        v-bind:class="{ hideIcon: !msg.replymessages.toggle }"
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div class="row pnlDate">
                <div class="col-md-9 col-sm-9">
                  <span class="spanDate">{{ msg.postedDate }}</span>
                  <br v-if="wXS === true || wSM === true" />
                  <span v-html="translation(15367) + ': ' + msg.tblQandASubject" class="pointer"></span>
                  <br v-if="wXS === true || wSM === true" />
                  <span class="spanName">{{ msg.postedName }}</span>
                </div>
                <div class="col-md-3 col-sm-3" v-if="wXL === true || wLG === true || wMD === true">
                  <div class="pull-right">
                    <span class="spanPrio" v-if="msg.tblQandACodePrio === 3">
                      <font-awesome-icon icon="exclamation" :class="'iconexclamation'" />
                    </span>
                    &nbsp;&nbsp;
                    <span v-on:click="ReplyReply(msg.windowOpen, msg.urlQandA)">
                      &nbsp;&nbsp;
                      <font-awesome-icon icon="reply" class="pointer" />&nbsp;&nbsp;
                    </span>
                    &nbsp;&nbsp;
                    <span>
                      <font-awesome-icon
                        icon="chevron-down"
                        class="initial pointer"
                        v-bind:class="{ hideIcon: msg.replymessages.toggle }"
                      />
                      <font-awesome-icon
                        icon="chevron-up"
                        class="initial pointer"
                        v-bind:class="{ hideIcon: !msg.replymessages.toggle }"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row pointer"
              v-if="msg.replymessages.toggle === true"
              v-on:click="toggleAntwoord(msg.tblQandAID)"
            >
              <div class="col-md-12 col-sm-12 col-xs-12">
                <span class="spanOntvangers" v-if="msg.replymessages.toggle === true">{{ msg.postedNameTo }}</span>
              </div>
            </div>
            <div class="row margin10" v-if="msg.replymessages.replydata && msg.replymessages.toggle === true">
              <div class="col-md-12 col-sm-12 col-xs-12">
                <span v-html="msg.replymessages.replydata.tblQandADescriptionText"></span>
              </div>
            </div>
            <div class="row spanQandABijlage">
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div
                  class="xvuploadclass"
                  v-if="
                    msg.replymessages.toggle === true &&
                    msg.replymessages.replydata &&
                    msg.replymessages.replydata.documenten !== null
                  "
                >
                  <XVupload
                    maximumfilecount="1"
                    name="uploadName"
                    :data-vv-as="translation(14930)"
                    v-model="msg.replymessages.replydata.documenten"
                    :bijlageicon="true"
                  ></XVupload>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FAMixin, util } from 'pevueglobal'
import XVupload from '@/components/XVupload'

export default {
  components: {
    XVupload,
  },
  name: 'XVqanda',
  props: [
    'postedDate',
    'postedName',
    'postedNameTo',
    'qandAencryptkey',
    'tblQandACodePrio',
    'tblQandACodeRelated',
    'tblQandAID',
    'tblQandAOriginalMessage',
    'tblQandASubject',
    'windowOpen',
    'urlQandA',
    'replymessages',
    'collapsed',
    'type',
  ],
  mixins: [FAMixin],
  data() {
    return {
      detailsVisible: false,
      antwoordenVisible: false,
      qandaDescriptiondata: null,
    }
  },
  created: function () {
    if (this.collapsed === 'false') {
      this.antwoordenVisible = true
    }
  },
  computed: {},
  methods: {
    toggleVraag() {
      this.detailsVisible = !this.detailsVisible
      this.getqandaDescriptiondata()
    },
    getqandaDescriptiondata() {
      if (!this.qandaDescriptiondata) {
        util
          .getDataApi('allroles/PEapi_QandA_Description', {
            qAndAID: this.tblQandAID,
            qandAencryptkey: this.qandAencryptkey,
          })
          .then((data) => {
            if (data != null) {
              this.qandaDescriptiondata = data.ds.data0[0]
              if (this.qandaDescriptiondata.documenten !== null) {
                let uploadfileids = this.qandaDescriptiondata.documenten.split(',')
                let uploadobjects = []
                uploadfileids.forEach((id) => {
                  uploadobjects.push({ uploadFileID: id, error: false })
                })
                this.qandaDescriptiondata.documenten = uploadobjects
              }
            }
          })
      }
    },
    toggleAntwoorden() {
      this.getqandaDescriptiondata()
      this.antwoordenVisible = !this.antwoordenVisible
    },
    toggleAntwoord(id) {
      let dd = this.replymessages.data.filter((d) => d.tblQandAID === id)[0]
      dd.replymessages.toggle = !dd.replymessages.toggle
      if (dd.replymessages.replydata === null) {
        util
          .getDataApi('allroles/PEapi_QandA_Description', {
            qAndAID: dd.tblQandAID,
            qandAencryptkey: dd.qandAencryptkey,
          })
          .then((data) => {
            dd.replymessages.replydata = data.ds.data0[0]
            if (dd.replymessages.replydata.documenten !== null) {
              dd.replymessages.replydata.documenten = data.ds.data1
            }
          })
      }
    },
    stopPropagationReply() {
      let e = window.event
      if (!e) {
        e.cancelBubble = true
      }
      if (e.stopPropagation) e.stopPropagation()
    },
    reply() {
      this.stopPropagationReply()
      if (this.windowOpen === 1) {
        var QandA = window.open(
          this.urlQandA,
          '_blank'
        )
        QandA.focus()
        return false
      } else {
        if (this.$route.path.includes('edu')) {
          window.location = '/edu/' + this.urlQandA
        } else if (this.$route.path.includes('prof')) {
          window.location = '/prof/' + this.urlQandA
        } else if (this.$route.path.includes('beheer')) {
          window.location = '/beheer/' + this.urlQandA
        }
      }
    },
    ReplyReply(popup, url) {
      this.stopPropagationReply()
      if (popup === 1) {
        var QandA = window.open(
          url,
          '_blank'
        )
        QandA.focus()
        return false
      } else {
        if (this.$route.path.includes('edu')) {
          window.location = '/edu/' + this.urlQandA
        } else if (this.$route.path.includes('prof')) {
          window.location = '/prof/' + this.urlQandA
        } else if (this.$route.path.includes('beheer')) {
          window.location = '/beheer/' + this.urlQandA
        }
      }
    },
  },
}
</script>
<style>
.spanQandABijlage .uploader-file-actions {
  display: none;
}
.spanQandABijlage .upload-success {
  background-color: transparent;
}
.spanQandABijlage .uploader-file-name {
  text-indent: 0;
  white-space: normal;
  word-break: break-all;
}
.spanQandABijlage .uploader-file-icon {
  display: none;
}
.spanQandABijlage .uploader-file {
  height: auto;
  line-height: inherit;
  border-bottom: 0px;
  border-left: 0px;
}
.spanQandABijlage .divIconPaperclip,
.spanQandABijlage .xvuploadclass {
  display: inline-block;
  padding-top: 10px;
  padding-bottom: 15px;
}
.spanQandABijlage .iconpaperclip {
  margin-bottom: 2px;
}
.spanQandABijlage .uploader-file-progress {
  display: none;
}
.spanQandABijlage .uploader-drop {
  display: none;
}
</style>
<style scoped>
.hideIcon {
  display: none;
}
.spanPrio .iconexclamation {
  color: red;
}
.qandaOuter {
  background-color: #ffffff;
  width: 100%;
  border: 1px solid #ccc;
  margin-bottom: 10px;
}
.qandaInnerTop {
  padding: 5px 20px 5px 20px;
}
.replyinnertop {
  padding: 5px 0 5px 0;
}
.qandaInnerBottom {
  padding: 0px 20px 5px 20px;
}
.qandaImportant {
  margin-right: 15px;
  color: red;
}
.colreplymsg {
  padding: 0 20px 0 20px;
}
.spanOntvangers,
.spanDate,
.spanQandABijlage,
.spanReplies,
.spanName {
  color: lightslategray;
}
.rowreplymsg {
  margin-left: 20px;
  margin-right: 0;
  background-color: #f3f3f6;
  margin-top: 5px;
}
.pnlDate {
  margin-top: 5px;
  margin-bottom: 5px;
}

@media (max-width: 768px) {
  .replyinnertop {
    padding: 0 0 5px 0;
  }
  .colreplymsg {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .qandaInnerTop {
    padding: 5px 20px 15px 20px;
  }
  .pnlDate {
    margin-top: 0px;
  }
}
</style>

